import { createSelector } from "@reduxjs/toolkit";
import filterDataBySearch from "Common/filterDataBySearch";
import { getAzureBlobStorageBackend } from "helpers/azure_helper";
import { useCallback,  useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import {
  addDiamondPrices as onAddDiamondPrices,
  getDiamondPrices as onGetDiamondPrices,
} from "slices/thunk";
import { formatBytes, getFileExtensionFromMimeType } from "utils/file";

const usePrices = ({
  show,
  setShow,
}: {
  show: boolean;
  setShow: (val: boolean) => void;
}) => {
  const dispatch = useDispatch<any>();

  const selectDataList = createSelector(
    (state: any) => state.Diamond,
    (state) => ({
      prices: state.diamondPrices,
    })
  );

  const {  prices } = useSelector(selectDataList);

  const [data, setData] = useState<any>([]);
  const [eventData, setEventData] = useState<any>();

  const [isEdit, setIsEdit] = useState<boolean>(false);

  const [selectfiles, setSelectfiles] = useState<any>(null);

  const handleAcceptfiles = (files: any) => {
    const newImages = files?.map((file: any) => {
      const fileExtension = getFileExtensionFromMimeType(file.type, file.name);
      return Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
        file: new Blob([file], { type: file.type }),
        blobName: `diamond-prices-${Date.now()}${
          fileExtension ? "." + fileExtension : ""
        }`,
      });
    });
    setSelectfiles(newImages[0]);
  };

  // Delete Modal
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const deleteToggle = () => setDeleteModal(!deleteModal);

  // Delete Data
  const onClickDelete = (cell: any) => {
    setDeleteModal(true);
    if (cell._id) {
      setEventData(cell);
    }
  };

  const handleDelete = () => {
    if (eventData) {
      // dispatch(onDeleteShape(eventData._id));
      setDeleteModal(false);
    }
  };
  //

  // Update Data
  const handleUpdateDataClick = (ele: any) => {
    setEventData({ ...ele });
    setIsEdit(true);
    setShow(true);
  };

  const handleUploadDiamondPricesFile = async () => {
    let url: string = "";
    if (selectfiles) {
      const containerName =
        process.env.REACT_APP_AZURE_BLOB_DIAMOND_PRICE_CONTAINER;
      if (containerName && selectfiles.blobName && selectfiles.file) {
        const azureBlobStorageBackend = getAzureBlobStorageBackend();
        url = (await azureBlobStorageBackend?.uploadExcelFile(
          containerName,
          selectfiles.blobName,
          selectfiles.file
        )) as string;
      } else {
        toast.error("Fill all the details!");
        setShow(false);
        setSelectfiles({});
        return "";
      }
    }
    return url;
  };

  const handleAddDiamondPrices = async () => {
    const diamondPricesFileUrl = await handleUploadDiamondPricesFile();
    const payload = { url: diamondPricesFileUrl };
    await dispatch(onAddDiamondPrices(payload));
    setShow(false);
    setSelectfiles({});
    dispatch(onGetDiamondPrices());
  };

  //
  const toggle = useCallback(() => {
    if (show) {
      setShow(false);
    } else {
      setShow(true);
    }
  }, [show]);

  // Search Data
  const filterSearchData = (e: any) => {
    const search = e.target.value;
    const keysToSearch = [
      "_id",
      "caratsFrom",
      "caratsTo",
      "color",
      "clarity",
      "prices.round",
      "prices.fancy",
    ];
    filterDataBySearch(prices, search, keysToSearch, setData);
  };

  return {
    show,
    data,
    setData,
    deleteModal,
    deleteToggle,
    handleDelete,
    filterSearchData,
    toggle,
    handleUpdateDataClick,
    onClickDelete,
    selectfiles,
    setSelectfiles,
    handleAcceptfiles,
    handleAddDiamondPrices,
    prices,
  };
};

export default usePrices;
